import util from '../util/util';
import ListenerGroup from '../util/ListenerGroup';

export interface BusyStatusReceipt {
  key: string
  reason: string
}

class GlobalActivityState {

  _listenerGroup = new ListenerGroup('GlobalBusyState');
  _busyKeysToReceipts = new Map<string, BusyStatusReceipt>();

  setBusy = (reason: string): BusyStatusReceipt => {
    const receipt: BusyStatusReceipt = {
      key: util.uuid(),
      reason: reason
    }
    this._busyKeysToReceipts.set(receipt.key, receipt);
    this._notifyListeners();
    return receipt;
  }

  setIdle = (receipt: BusyStatusReceipt): void => {
    this._busyKeysToReceipts.delete(receipt.key);
    this._notifyListeners();
  }

  isIdle = (): boolean => {
    return this._busyKeysToReceipts.size === 0;
  }

  isBusy = (): boolean => {
    return this._busyKeysToReceipts.size > 0;
  }

  registerListener = (listener: any) => {
    this._listenerGroup.registerListener(listener);
  };

  unregisterListener = (listener: any) => {
    this._listenerGroup.unregisterListener(listener);
  };

  _notifyListeners = () => {
    this._listenerGroup.notifyListeners(undefined);
  };

}

export default new GlobalActivityState();
